export const AvatarIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="32" cy="26" r="5" stroke="#7B8490" strokeWidth="2" />
      <path
        d="M22.897 40.8472C24.3723 37.3064 27.8319 35 31.6678 35H32.3322C36.1681 35 39.6277 37.3064 41.103 40.8472V40.8472C41.5297 41.8713 40.7773 43 39.6678 43H24.3322C23.2227 43 22.4703 41.8713 22.897 40.8472V40.8472Z"
        stroke="#7B8490"
      />
    </svg>
  );
};
